var _rect, _path, _rect2, _rect3, _circle, _rect4, _rect5, _path2, _rect6, _path3, _rect7, _path4, _path5, _rect8, _rect9, _circle2, _path6, _circle3, _circle4, _path7, _path8, _path9, _circle5, _circle6, _path10, _path11, _path12, _path13, _g, _rect10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAonAdvancedSetup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 518,
    height: 308,
    fill: "none",
    viewBox: "0 0 518 308",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 510,
    height: 300,
    x: 4,
    y: 1,
    fill: "#fff",
    rx: 11.652
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M459.792 90.485 424.547 80.22a5.794 5.794 0 0 1 3.26 6.81l-48.095 178.702a6.046 6.046 0 0 1-6.091 4.469l35.25 9.487 50.921-189.203Z",
    opacity: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 142.295,
    height: 195.935,
    x: 378.394,
    y: 271.1,
    stroke: "#5C5C5C",
    strokeWidth: 0.745,
    rx: 5.588,
    transform: "rotate(-164.937 378.394 271.1)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 134.845,
    height: 177.31,
    x: 377.314,
    y: 260.779,
    stroke: "#C6C6C6",
    strokeWidth: 0.745,
    rx: 5.588,
    transform: "rotate(-164.937 377.314 260.779)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 310.434,
    cy: 248.74,
    r: 1.502,
    stroke: "#4D4D4D",
    strokeWidth: 0.745,
    transform: "rotate(15.063 310.434 248.74)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 68.54,
    height: 29.8,
    x: 334.91,
    y: 85.807,
    stroke: "url(#d)",
    strokeWidth: 0.745,
    opacity: 0.3,
    rx: 3.353,
    transform: "rotate(15.063 334.91 85.807)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 69.357,
    height: 17.495,
    x: 267.449,
    y: 194.564,
    fill: "#4D4D4D",
    opacity: 0.3,
    rx: 3.725,
    transform: "rotate(15.063 267.449 194.564)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 0.745,
    d: "m271.859 202.222 24.135 6.495M270.56 207.049l44.046 11.854"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 68.54,
    height: 29.8,
    x: 288.042,
    y: 119.484,
    stroke: "#000",
    strokeWidth: 0.745,
    opacity: 0.3,
    rx: 3.353,
    transform: "rotate(15.063 288.042 119.484)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeWidth: 0.745,
    d: "m291.627 136.264 24.134 6.496M292.788 131.948l24.135 6.496M290.327 141.092l44.046 11.854"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 68.54,
    height: 17.88,
    x: 317.861,
    y: 184.987,
    fill: "#4D4D4D",
    rx: 3.725,
    transform: "rotate(15.063 317.861 184.987)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 0.745,
    d: "m322.271 192.644 12.067 3.248m12.067 3.247-6.938-1.867M320.971 197.471l44.046 11.854"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "m195.383 193.524-31.281 7.646a5.355 5.355 0 0 1 3.842 3.693l15.476 52.927a4.978 4.978 0 0 1-3.134 4.625l-3.816 1.524 36.554-10.373-17.641-60.042Z",
    opacity: 0.3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 65.192,
    height: 119.14,
    x: 70.447,
    y: 295.542,
    stroke: "url(#f)",
    strokeWidth: 0.745,
    rx: 5.588,
    transform: "rotate(-106.373 70.447 295.542)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 57.099,
    height: 107.152,
    x: 76.418,
    y: 290.351,
    fill: "url(#g)",
    stroke: "url(#h)",
    strokeWidth: 0.745,
    opacity: 0.3,
    rx: 5.588,
    transform: "rotate(-106.373 76.418 290.351)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.148,
    cy: 54.561,
    r: 38.197,
    stroke: "url(#i)",
    strokeWidth: 0.745,
    transform: "rotate(15 106.148 54.56)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5C5C5C",
    strokeWidth: 0.745,
    d: "m120.636 74.222 5.333 5.356a3.183 3.183 0 1 0 4.511-4.492l-5.343-5.366"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.087,
    cy: 54.455,
    r: 24.404,
    stroke: "#5C5C5C",
    strokeWidth: 0.745,
    transform: "rotate(-45 106.087 54.455)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.087,
    cy: 54.455,
    r: 21.221,
    fill: "url(#j)",
    transform: "rotate(-45 106.087 54.455)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#k)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.745,
    d: "m210.1-10.073-27.863 55.017-11.305 12.466 1.526-16.424 26.593-54.156"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.745,
    d: "M182.237 44.944c-1.15-1.695-4.611-4.58-9.779-3.958M176.299 51.48l-5.12 2.27"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "m169.68 53.627 2.003-2.838.647-10.153L193.693-2.88l-5.29-3.617-19.861 46.536-.215 13.146c-.013.733.93 1.041 1.353.442Z",
    opacity: 0.4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.505,
    cy: 135.488,
    r: 0.376,
    stroke: "#4D4D4D",
    strokeWidth: 0.738,
    transform: "rotate(-1.825 174.505 135.488)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.157,
    cy: 137.1,
    r: 52.15,
    stroke: "#4D4D4D",
    strokeDasharray: "1.49 1.49",
    strokeWidth: 0.745,
    opacity: 0.4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4D4D4D",
    strokeWidth: 0.745,
    d: "M268.787 129.65c-3.744-38.472-36.175-68.54-75.63-68.54-41.968 0-75.99 34.022-75.99 75.99 0 27.94 15.079 52.358 37.543 65.56m14.607 6.615a75.9 75.9 0 0 0 23.84 3.815c25.491 0 48.05-12.551 61.835-31.811",
    opacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4D4D4D",
    strokeDasharray: "1.49 1.49",
    strokeWidth: 0.745,
    d: "M281.334 84.205c-17.978-29.906-50.741-49.915-88.177-49.915-1.749 0-3.487.044-5.215.13m54.69 192.825c-14.678 8.073-31.54 12.665-49.475 12.665-5.06 0-10.035-.366-14.9-1.072m-55.158-26.493c-20.15-18.769-32.752-45.535-32.752-75.245 0-14.564 3.029-28.421 8.49-40.975m48.13-50.9c8.789-4.427 18.3-7.63 28.31-9.386",
    opacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#m)",
    strokeWidth: 0.745,
    d: "m222.957 298.765 14.155-34.27 105.045 34.27",
    opacity: 0.3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#n)",
    strokeWidth: 0.745,
    d: "m461.739 235.44-34.27-14.155 34.27-105.045",
    opacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5C5C5C",
    d: "M192.679 159.977c-.52 0-1.111-.26-1.561-.52-12.863-7.992-17-10.31-17-17.805v-17.828c0-2.578.733-3.476 3.144-4.375 4.115-1.584 9.553-3.665 13.667-5.154.615-.213 1.159-.379 1.75-.379s1.135.166 1.75.379c4.138 1.418 9.529 3.57 13.643 5.154 2.435.922 3.168 1.797 3.168 4.375v17.828c0 7.495-4.043 9.978-17.024 17.805-.426.26-1.041.52-1.537.52Zm0-1.845c.402 0 .898-.283 1.253-.543 10.971-7.141 15.559-9.056 15.559-16.126v-17.308c0-1.703-.332-2.318-1.537-2.791-2.578-.969-11.303-4.327-13.88-5.296-.591-.236-1.088-.378-1.395-.378-.331 0-.828.118-1.395.378-2.577.969-11.326 4.28-13.88 5.296-1.229.473-1.537 1.088-1.537 2.791v17.308c0 7.07 4.516 9.056 15.535 16.126.378.26.851.543 1.277.543Zm-2.53-11.16c-.378 0-.615-.142-.899-.473l-7.046-8.205c-.165-.236-.284-.496-.284-.733 0-.52.402-.875.875-.875.308 0 .568.119.804.402l6.503 7.638 11.846-18.443c.213-.284.496-.497.804-.497.449 0 .875.402.875.851 0 .213-.119.473-.213.662l-12.39 19.2c-.237.308-.52.473-.875.473Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M31 11h461v261H31z",
    style: {
      mixBlendMode: "overlay"
    }
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 509.636,
    height: 299.636,
    x: 4.182,
    y: 1.182,
    stroke: "#DEE0E2",
    strokeWidth: 0.364,
    rx: 11.47
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 379.186,
    x2: 407.893,
    y1: 203.655,
    y2: 211.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 368.917,
    x2: 368.917,
    y1: 123.345,
    y2: 89.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 159.284,
    x2: 183.946,
    y1: 234.493,
    y2: 230.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 105.586,
    x2: 107.821,
    y1: 415.95,
    y2: 313.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 106.054,
    x2: 106.586,
    y1: 512.38,
    y2: 317.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 109.378,
    x2: 108.261,
    y1: 398.35,
    y2: 298.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 124.814,
    x2: 96.454,
    y1: 88.295,
    y2: 35.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 97.386,
    x2: 104.162,
    y1: 3.33,
    y2: 51.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 180.726,
    x2: 193.754,
    y1: 37.564,
    y2: 11.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 188.926,
    x2: 182.85,
    y1: 48.049,
    y2: 17.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 282.557,
    x2: 282.557,
    y1: 264.495,
    y2: 298.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 427.469,
    x2: 461.739,
    y1: 175.84,
    y2: 175.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 492,
    x2: 31,
    y1: 11,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#905DCF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 510,
    height: 300,
    x: 4,
    y: 1,
    fill: "#fff",
    rx: 11.652
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M157.06 100.116h72.638v72.638H157.06z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 518,
    height: 308,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0666667 0 0 0 0 0.0666667 0 0 0 0 0.0666667 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10346_11375"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10346_11375",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAonAdvancedSetup);
export default __webpack_public_path__ + "static/media/AonAdvancedSetup.d2a7dd38bcfd58e95f6de715cdc414c4.svg";
export { ForwardRef as ReactComponent };